import React from 'react';
import './footer.css'; // External CSS
import '@fortawesome/fontawesome-free/css/all.min.css'; // Font Awesome
import logo from "../../assets/new-logo.png";

function Footer() {
  return (
    <footer className="footer mt-5">
      <div className="container ">
        <div className="row mt-8">

          <div className="footer-col1 footer-col">
            {/* <h4>company<div className='underline-footer'><span></span></div></h4>
            <ul>
              <li><a href="#">about us</a></li>
              <li><a href="#">our services</a></li>
              <li><a href="#">privacy policy</a></li>
              <li><a href="#">affiliate program</a></li>
            </ul> */}
            <img src={logo} width={300} />
            <p>New Sky Property & Projects Private Limited (NSPP) is a professionally managed Private Limited Company based in Chennai, Tamil Nadu. Established in 2022, NSPP is built on over 25 years of 
                experience in real estate and construction services.</p>
          </div>

          <div className=" footer-col2 footer-col">
            <h4>Links<div className='underline-footer'><span></span></div></h4>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/aboutmain">About us</a></li>
              <li><a href="/">Our Service</a></li>
              <li><a href="/gallery">Gallery</a></li>
              <li><a href="/contact">Contact us</a></li>
            </ul>
          </div>

          <div className="footer-col2 footer-col">
            <h4>Links<div className='underline-footer'><span></span></div></h4>
            <ul>
              <li><a href="#"></a></li>
              <li><a href="/construction">Construction</a></li>
              <li><a href="/realestate">Real Estate</a></li>
              <li><a href="/otherservice">Other Services</a></li>
            </ul>
          </div>

          <div className=" footer-col2 footer-col">
            <h4>Social Links<div className='underline-footer'><span></span></div></h4>
            <div className="social-links">
              <a href="#"><i className="fab fa-facebook-f"></i></a>
              <a href="#"><i className="fab fa-twitter"></i></a>
              <a href="#"><i className="fab fa-instagram"></i></a>
              <a href="#"><i className="fab fa-linkedin-in"></i></a>
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
}

export default Footer;
